import { useEffect } from 'react';

/**
 * Knöpfe in Aktionszeilen (`.row-actions`) bekommen eine Art (`data-act`), nach der das Stylesheet sie bei schmalen Fenstern als Symbol zeigt (styles.css, „Aktionen als Symbole“).
 * Die Beschriftung bleibt im Knopf (Screenreader) und steht als Tooltip (`title`) beim Darüberfahren. Erkannt wird sie am Text, damit sich die Seiten der Einrichtung nicht einzeln
 * ändern müssen. Ein Knopf mit anderem Text (zum Beispiel „Neuer Link“ oder „Veröffentlichen (3)“) bleibt, wie er ist.
 */
const ACTIONS: Record<string, string> = {
  Bearbeiten: 'edit',
  Umbenennen: 'edit',
  Löschen: 'delete',
  Entfernen: 'delete',
  '↑': 'up',
  '↓': 'down',
  Speichern: 'save',
  Abbrechen: 'cancel',
};

function tag(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>('.row-actions button, .row-actions a').forEach((el) => {
    const text = (el.textContent ?? '').trim();
    const act = ACTIONS[text];
    if (!act) {
      // Der Text hat sich geändert (zum Beispiel „Bearbeiten“ wird zu „Zuklappen“): Symbol und eigener Tooltip fallen weg
      if (el.dataset.act) {
        delete el.dataset.act;
        if (el.dataset.actTitle === '1') {
          el.removeAttribute('title');
          delete el.dataset.actTitle;
        }
      }
      return;
    }
    if (el.dataset.act !== act) el.dataset.act = act;
    if (!el.hasAttribute('title')) {
      el.title = el.getAttribute('aria-label') ?? text;
      el.dataset.actTitle = '1';
    }
  });
}

/** Einmal im Rahmen des Backoffice einbinden. Beobachtet die Seite und kennzeichnet neue Aktionsknöpfe. */
export function useRowActionIcons(): void {
  useEffect(() => {
    let frame = 0;
    const run = () => {
      frame = 0;
      tag(document);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(run);
    };
    run();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
}
